import operationHandler from './helpers/operation-handler';

export const helpersPlugin = {
    install: (Vue) => {
        Vue.prototype.$operationHandler = (value, opration, valueToCompare) => new operationHandler(value, opration, valueToCompare);
    }
}